import React from 'react';
import { DeviceId, EcsDevice } from 'shared/models';
import { DeviceLineItem } from '../deviceLineItem/DeviceLineItem';
import { useDeviceTypes } from 'hooks';

export type Props = {
    editing: boolean;
    devices: EcsDevice[];
    online: Record<DeviceId, boolean>;
    busy: boolean;
    onAssign?(deviceId: DeviceId): void;
    onDelete?(deviceId: DeviceId): void;
    onRemove?(deviceId: DeviceId): void;
};

export const DeviceList = ({ editing, devices, online, busy, onAssign, onDelete, onRemove }: Props) => {
    const { deviceTypes } = useDeviceTypes();
    return (
        <div>
            { devices.filter(d => !!d.macAddress).sort((a, b) => a.macAddress.localeCompare(b.macAddress)).map(d =>
                <DeviceLineItem
                    deviceTypes={ deviceTypes }
                    key={ d.deviceId }
                    device={ d }
                    online={ online[d.deviceId] }
                    busy={ busy }
                    showRemove={ !!onRemove && d.deviceClass !== 'gateway' }
                    showAssign={ editing && !!onAssign && d.deviceClass !== 'gateway' }
                    showDelete={ !online[d.deviceId] && !editing && !!onDelete && d.deviceClass !== 'gateway' }
                    onAssign={ onAssign && (() => onAssign(d.deviceId)) }
                    onDelete={ onDelete && (() => onDelete(d.deviceId)) }
                    onRemove={ onRemove && (() => onRemove(d.deviceId)) }
                />
            ) }
        </div>
    );
};